import type { DateTime } from "luxon";
import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { useWeekIndex } from "../../contexts/WeekIndexProvider";
import { Tooltip } from "../tooltip";
import Style from "./ChartDateArea.module.scss";

type Props = {
	day: DateTime;
	labelEnabled?: boolean;
	label?: string;
	color?: string;
	shiftNo?: number;
	isHospitalDemo?: boolean;
	/** Area legend (ICU / TELE), rendered under the date. */
	legend?: ReactNode;
};
export const ChartDateArea: FC<Props> = ({ day, labelEnabled, shiftNo, color, label, isHospitalDemo, legend }) => {
	const { t } = useTranslation();
	const { hospitalData } = useHospitalData();
	const { weekIndex } = useWeekIndex();

	return (
		<div className={isHospitalDemo ? `${Style.dateAreaContainer} ${Style.demo}` : Style.dateAreaContainer}>
			{labelEnabled ? (
				<Tooltip
					id="caseLoad"
					text={t(labelEnabled ? "tooltip.caseLoad" : "")}
					showTooltip={true}
					component={
						<div className={Style.day}>
							{`${day.toFormat("cccc")} ${shiftNo !== -1 && shiftNo !== undefined ? t(hospitalData?.weeks[weekIndex]?.weeklyShifts[shiftNo]?.type) : ""}`}
						</div>
					}
				/>
			) : (
				<div className={Style.day}>
					{`${day.toFormat("cccc")} ${shiftNo !== -1 && shiftNo !== undefined ? t(hospitalData?.weeks[weekIndex]?.weeklyShifts[shiftNo]?.type) : ""}`}
				</div>
			)}
			<div className={labelEnabled ? Style.titleOverview : Style.title} style={{ color: color }}>
				{day.toFormat("MMM d")}
			</div>
			{labelEnabled && <p className={Style.label}>{label}</p>}
			{legend}
		</div>
	);
};
